<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        จัดการคำถามที่พบบ่อย
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#"> <i class="fa fa-dashboard"></i>จัดการคำถามที่พบบ่อย </a>
        </li>
        <!-- <li class="active">การจัดกลุ่มผู้ให้บริการ</li> -->
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="คำถาม" prop="Connection_type">
                            <el-input
                              placeholder="กรุณากรอกคำค้นหา"
                              v-model="question"
                            ></el-input>
                          </el-form-item>
                        </div>
                        <div class="col-sm-3" style="margin-top:33px;">
                          <el-button type="primary" @click="search(null)" size="mini"
                            >ค้นหา</el-button
                          >
                        </div>
                      </div>
                    </el-form>
                    <div class="pull-right box_add" v-if="user_permission.add">
                      <button
                        @click="Add_typegroup"
                        class="btn btn-info btn_custom"
                      >
                        <i class="fa fa-plus"></i> เพิ่มคำถามที่พบบ่อย
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-body">
                <div class="wrapper_typegroup">
                  <data-tables-server
                    @query-change="search"
                    :data="tableData"
                    :pagination-props="{ pageSizes: [5, 10, 15] }"
                    :current-page.sync="page"
                    :page-size.sync="pageSize"
                    :total="total"
                  >
                    <el-table-column type="index" :index="index_method" width="50"> </el-table-column>
                    <el-table-column
                      class="text-group"
                      prop="question_th"
                      label="คำถาม"
                    ></el-table-column>
                    <el-table-column label="การแสดงผล" width="100">
                      <template slot-scope="scope">
                        {{
                          scope.row.visible_status === 0 ? "ไม่แสดง" : "แสดง"
                        }}
                      </template>
                    </el-table-column>
                    <el-table-column sortable="custom" prop="created_at" label="วันที่สร้างข้อมูล" width="160">
                      <template slot-scope="scope">
                        {{
                          scope.row.created_at
                            ? moment(scope.row.created_at).add(543,'Y').format("DD/MM/YYYY")
                            : "-"
                        }}
                      </template>
                    </el-table-column>
                    <el-table-column sortable="custom" prop="updated_at" label="วันอัปเดตข้อมูล" width="160">
                      <template slot-scope="scope">
                        {{
                          scope.row.updated_at
                            ? moment(scope.row.updated_at).add(543,'Y').format( "DD/MM/YYYY")
                            : "ไม่มีการอัปเดตข้อมูล"
                        }}
                      </template>
                    </el-table-column>
                    <el-table-column sortable="custom" prop="updated_by_admin" label="อัปเดตโดย" width="180">
                      <template
                        slot-scope="scope"
                      >{{ scope.row.updated_by_admin ? scope.row.first_name + ' ' + scope.row.last_name :'ไม่มีการอัปเดต'}}</template>
                    </el-table-column>
                    <el-table-column
                    v-if="user_permission.edit || user_permission.delete"
                      label="จัดการ"
                      align="center"
                      width="170"
                      fixed="right"
                    >
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="ดูข้อมูล" placement="top">
                          <el-button
                            size="mini"
                            type="success"
                            @click="handleView(scope.row)"
                          >
                            <i class="el-icon-view"></i>
                          </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="แก้ไข" placement="top">
                          <el-button
                          v-if="user_permission.add"
                            size="mini"
                            type="primary"
                            @click="handleEdit(scope.row)"
                          >
                            <i class="el-icon-edit"></i>
                          </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="ลบ" placement="top">
                          <el-button
                          v-if="user_permission.edit"
                            class="custom-btn"
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.row.faq_id)"
                          >
                            <i class="el-icon-delete-solid"></i>
                          </el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </data-tables-server>
                  <el-dialog title="คำถามที่พบบ่อย" :visible.sync="view_dialog" width="75%">
                    <div class="row">
                      <div class="text-group">
                        <div class="col-sm-3" align="right"><b>คำถาม (ภาษาไทย)</b> : </div>
                        <div class="col-sm-9">{{ dialog_data.question_th }}</div>
                        <div class="col-sm-12"><br></div>
                      </div>
                      <div class="text-group">
                        <div class="col-sm-3" align="right"><b>คำอธิบาย (ภาษาไทย)</b> : </div>
                        <div class="col-sm-9">{{ dialog_data.answer_th }}</div>
                        <div class="col-sm-12"><br></div>
                      </div>
                      <div class="text-group">
                        <div class="col-sm-3" align="right"><b>คำถาม (ภาษาอังกฤษ)</b> : </div>
                        <div class="col-sm-9">{{ dialog_data.question_en }}</div>
                        <div class="col-sm-12"><br></div>
                      </div>
                      <div class="text-group">
                        <div class="col-sm-3" align="right"><b>คำอธิบาย (ภาษาอังกฤษ)</b> : </div>
                        <div class="col-sm-9">{{ dialog_data.answer_en }}</div>
                        <div class="col-sm-12"><br></div>
                      </div>
                      <div class="text-group">
                        <div class="col-sm-3" align="right"><b>สถานะการแสดงผล</b> : </div>
                        <div class="col-sm-9">{{ dialog_data.visible_status === 0 ? 'ไม่แสดงผล' : 'แสดงผล' }}</div>
                        <div class="col-sm-12"><br></div>
                      </div>
                      <div class="text-group">
                        <div class="col-sm-3" align="right"><b>วันที่สร้างข้อมูล</b> : </div>
                        <div class="col-sm-9">{{ dialog_data.created_at ? moment(dialog_data.created_at).add(543, 'Y').format('DD/MM/YYYY') : '' }}</div>
                        <div class="col-sm-12"><br></div>
                      </div>
                      <div class="text-group">
                        <div class="col-sm-3" align="right"><b>วันอัปเดตข้อมูล</b> : </div>
                        <div class="col-sm-9">{{ dialog_data.updated_at ? moment(dialog_data.updated_at).add(543, 'Y').format('DD/MM/YYYY') : '' }}</div>
                        <div class="col-sm-12"><br></div>
                      </div>
                      <div class="text-group">
                        <div class="col-sm-3" align="right"><b>อัปเดตโดย</b> : </div>
                        <div class="col-sm-9">{{ dialog_data.updated_by_admin ? dialog_data.first_name+' '+dialog_data.last_name : '' }}</div>
                        <div class="col-sm-12"><br></div>
                      </div>
                    </div>
                  </el-dialog>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      user_permission : {
        add : false,
        edit : false,
        delete : false
      },
      label_position: "top",
      question: "",
      page: 1,
      pageSize: 5,
      view_dialog : false,
      dialog_data : {}
    };
  },
  computed: {
    ...mapState({
      tableData: store => store.questionStore.tableData,
      total: store => store.questionStore.total
    })
  },
  mounted() {
    const permission = JSON.parse(atob(this.$cookies.get("user_nbtc").permission)).Manage_question
    this.user_permission.add = permission.includes('add')
    this.user_permission.edit = permission.includes('edit')
    this.user_permission.delete = permission.includes('delete')
  },
  methods: {
    ...mapActions({
      searchQuestion: "questionStore/searchQuestion",
      remove:"questionStore/remove"
    }),
    search(queryInfo) {
      if (queryInfo == null) {
        this.page = 1
        queryInfo = {
          page: this.page,
          pageSize: this.pageSize,
          sort: null
        }
      }
      this.searchQuestion({ question: this.question, queryInfo: queryInfo });
    },
    handleDelete(id) {
      this.$confirm("ลบคำถามนี้ใช่ หรือไม่", "แจ้งเตือน", {
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        type: "warning"
      })
        .then(() => {
          this.remove({faq_id: id, admin_id: this.$cookies.get("user_nbtc").admin_id}).then(() => { this.search(null) })
        })
        .catch(() => {});
      // this.dialogVisible = true;
      // this.tableData.splice(this.tableData.indexOf(row), 1);
    },
    handleEdit(row) {
      this.$router.push({ 
        name: "Manage_questionEdit", 
        query: { faq_id: row.faq_id }
      });
    },
    handleView(row){
      this.dialog_data = row
      this.view_dialog = true
    },
    index_method(index) {
      return index + (this.pageSize * (this.page - 1)) + 1
    },
    Add_typegroup() {
      this.$router.push({ name: "Manage_question_add" });
    }
    // submitUpload() {
    //   this.$refs.upload.submit();
    // }
  }
};
</script>
<style scoped>
 .text-group{
    word-break: break-word;
 }
</style>